<template>
  <div class="detile" v-loading="Delectloading" :element-loading-text="textContent">
    <!--    <el-dropdown  trigger="click">
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
           <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </el-dropdown-menu>
    </el-dropdown>-->
    <el-form
      :rules="rules"
      :model="dataJson"
      ref="dataForm"
      class="fromData"
      label-position="right"
      label-width="40%"
    >
      <el-form-item :label="dataobjs.wangguanid" prop="gatewayid" style="width:50%">
        <el-input
          v-model="dataJson.gatewayid"
          maxlength="12"
          :disabled=" bentflag ==  false? disableDt:bentflag "
        ></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.wangguanmingcheng" prop="name" style="width:50%">
        <el-input v-model="dataJson.name"></el-input>
      </el-form-item>
      <!-- <el-form-item label="端口号" prop="port" style="width:50%">
        <el-input v-model="dataJson.port"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="ip地址" prop="ip" style="width:50%">
        <el-input v-model="dataJson.ip"></el-input>
      </el-form-item>-->
      <el-form-item :label="dataobjs.wangguanzhuangtai" style="width:50%">
        <el-select
          v-model="dataJson.state"
          value-key="id"
          placeholder="请选择"
          style="width:100%"
          disabled
        >
          <el-option
            v-for="item in state"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="观察要素个数（通道）"  style="width:50%; white-space:nowrap">
          <el-input v-model="dataJson.factorcount"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="波特率" prop="baudrate" style="width:50%">
        <el-input v-model="dataJson.baudrate"></el-input>
      </el-form-item>
      <el-form-item label="奇偶校验" prop="parity" style="width:50%">
        <el-input v-model="dataJson.parity"></el-input>
      </el-form-item>-->
      <el-form-item :label="dataobjs.shebeianzhuangdizhi" prop="address" style="width:50%">
        <el-input v-model="dataJson.address"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.shebeianzhuangdizhi" style="width:50%">
        <el-upload
          class="upload-demo"
          action="#"
          :auto-upload="false"
          list-type="picture"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          :on-change="handlePreview"
          multiple
          :file-list="fileList"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <el-button
          size="small"
          type="primary"
          class="deitlLint"
          icon="el-icon-zoom-in"
          @click="imgDelenetLing"
        ></el-button>
      </el-form-item>

      <!-- <el-form-item label="海拔" style="width:50%">
        <el-input v-model="dataJson.altitude"></el-input>
      </el-form-item>-->
      <el-form-item :label="dataobjs.shebeishengchanriqi" style="width:50%">
        <el-date-picker
        :disabled="bentflagJxs"
          v-model="dataJson.productiondate"
          type="date"
          placeholder="选择日期"
          format="yyyy/MM/dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <el-form-item :label="dataobjs.youxiaoqi" style="width:50%">
        <el-date-picker
          :disabled="bentflagJxs"
          v-model="dataJson.exprirydate"
          type="date"
          placeholder="选择日期"
          format="yyyy/MM/dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>

      <!-- <el-form-item label="可移动" style="width:50%">
        <el-select v-model="dataJson.ismove " placeholder="请选择" value-key="id" style="width:100%">
          <el-option
            v-for="item in ismove"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>-->
      <el-form-item :label="dataobjs.shujushangchuanpinlv" prop="uploadtime" style="width:50%">
        <el-input v-model="dataJson.uploadtime" :min="10"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjs.gongdianleixing" disabled prop="name" style="width:50%">
        <el-select
          v-model="dataJson.powertype"
          placeholder="请选择"
          @change="mycheanges"
            :disabled="bentflagJxs"
          style="width:100%"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="dataobjs.shifouchangzaixian" disabled prop="name" style="width:50%">
        <el-select
          v-model="dataJson.isallonline"
          placeholder="请选择"
          @change="mycheanges"
          style="width:100%"
            :disabled="bentflagJxs"
        >
          <el-option
            v-for="item in optionsisallonline"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="dataobjs.jingdu" style="width:50%">
        <el-input v-model="dataJson.longitude"></el-input>
        <!-- <img src="@/assets/img/coordinate.png" class="postFit" alt /> -->
      </el-form-item>
      <el-form-item :label="dataobjs.weidu" style="width:50%">
        <el-input v-model="dataJson.latitude"></el-input>
        <!-- <img src="@/assets/img/coordinate.png" class="postFit" alt /> -->
      </el-form-item>
      <el-form-item :label="dataobjs.kekongzhi" style="width:50%">
        <el-select v-model="dataJson.iscontrol" value-key="id" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in iscontrol"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="dataobjs.kejiankong" value-key="id" style="width:50%">
        <div class="box_flex">
          <el-select
            :disabled="bentflagJxs"
            v-model="dataJson.ismonitor"
            value-key="id"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option
              v-for="item in ismonitor"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!--  v-if="dataJson.ismonitor == 1" -->
          <el-button
            size="mini"
            style="height: 30px; margin-top: 6px;"
            type="primary"
            @click="guan_lian_sexian"
          >{{dataobjs.guanlianshexiangtou}}</el-button>
        </div>
      </el-form-item>

      <!-- 地图 -->
      <!-- <div class="mapLint">
        <div id="allmap" ref="allmap"></div>

        <div class="werp_in">
          <div id="r-result">
            请输入地址:
            <input type="text" id="suggestId" size="20" value="百度" style="width:150px;" />
          </div>
          <div
            id="searchResultPanel"
            style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;z-index:10000000"
          ></div>
        </div>
      </div>-->

      <div class="mapLint">
        <div id="allmap" ref="allmap"></div>

        <div class="werp_in">
          <div id="r-result">
            请输入地址:
            <input type="text" id="suggestId" size="20" value="百度" style="width:150px;" />
          </div>
          <div
            id="searchResultPanel"
            style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;z-index:10000000"
          ></div>
        </div>
      </div>
    </el-form>

    <div style="text-align: center;" class="btenEtiel">
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelClick">{{dataobjs.quxiao}}</el-button>
        <!-- 判斷是平台管理员和平台子账号 -->
        <el-button
          type="primary"
          @click="deterMine('dataForm')"
          v-if="roletypeValue == 0 && isagree == 0"
        >{{dataobjs.baocun}}</el-button>
        <!-- 判断经销商和经销商子账号 -->
        <el-button
          type="primary"
          @click="deterMine('dataForm')"
          v-if="roletypeValue == 1 && isagree == 0"
        >{{dataobjs.baocun}}</el-button>
        <!-- 判断客户经销商主账号和子账号 -->
         <el-button
          type="primary"
          @click="deterMine('dataForm')"
          v-if="roletypeValue == 2 && isagree == 0"
        >{{dataobjs.baocun}}</el-button>
      </span>
    </div>

    <!-- 对话框 -->
    <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="20%" :modal="false">
      <el-input v-model="nametext"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleText">确 定</el-button>
      </span>
    </el-dialog>-->

    <!-- 图片闲情 -->
    <div class="dingLinetli">
      <el-dialog :visible.sync="dialogVisibleImgs" :modal="false">
        <img width="100%" :src="dataJson.addressphoto" alt />
      </el-dialog>
    </div>

    <!-- table提示框 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleTab" width="50%" :modal="false">
      <el-table :data="tableData" style="width: 100%;  ">
        <el-table-column prop="date" label="通道号"></el-table-column>
        <el-table-column prop="name" label="要素类型"></el-table-column>
        <el-table-column prop="address" label="默认要素别名"></el-table-column>
        <el-table-column prop="address" label="上线修改"></el-table-column>
        <el-table-column prop="address" label="下限(可修改)"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">
              选择
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-button type="text" size="small" @click="mydetile">修改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleTabHide">确 定</el-button>
      </span>
    </el-dialog>
    <!-- table表格的修改 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleEdit" width="40%" :modal="false">
      <el-form
        :model="dataJson"
        ref="dataForm"
        class="fromData"
        label-position="right"
        label-width="47%"
      >
        <el-form-item label="要素类型" style="width:50%">
          <el-input v-model="dataJson.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="默认要素别名" style="width:50%">
          <el-input v-model="dataJson.name"></el-input>
        </el-form-item>
        <el-form-item label="上限(可修改)" style="width:50%">
          <el-input v-model="dataJson.name"></el-input>
        </el-form-item>
        <el-form-item label="下限(可修改)" style="width:50%">
          <el-input v-model="dataJson.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleEdit = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleEditClick">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下拉框 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleselect" width="20%" :modal="false">
      <el-select v-model.number="value" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleselect = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleselect">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 侧边框 -->

    <!-- 新建摄像头 -->
    <el-dialog
      :title="dataobjs.guanlianshexiangtou"
      :visible.sync="dialogVisiblesyx"
      width="40%"
      :modal="false"
      center
    >
      <el-form
        :model="dataJson"
        ref="dataForm"
        class="fromData"
        label-position="right"
        label-width="47%"
      >
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
          v-if="getData != ''"
        >
          <el-checkbox v-for="city in getData" :label="city.id" :key="city.id">{{city.name}}</el-checkbox>
        </el-checkbox-group>
        <div v-else>暂无数据</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblesyx = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisiblesyxAdd">确 定</el-button>
      </span>
    </el-dialog>
    <div style="display:none">{{nwimgs}} {{handChend}}</div>
  </div>
</template>
<script>
import { autoUpload, gatewayAadd, lang_fend } from "@/network/index";
import axios from "axios";
export default {
  props: {
    checkedCitiesdata: {
      type: Array,
      default: [],
    },
    getData: {
      type: Array,
      default: [],
    },
    disableDt: {
      type: Boolean,
      default: false,
    },
    bentflagJxs:{
        type: Boolean,
      default: false,
    },
    bentflag: {
      type: Boolean,
      default: false,
    },

    dataJson: {
      type: Object,
      default: {},
    },
    upperand: {
      type: Function,
      default: Function,
    },
    closefale: {
      type: Function,
      default: Function,
    },
    postData: {
      type: Function,
    },
    // apiFly: {
    //   type: Boolean,
    // },
    areauuid: {
      type: String,
      default: "",
    },
  },
  data() {
    // 判断最大值和最小值
    let speed1 = (rule, value, callback) => {
      let minSpeed = 9;
      let maxSpeed = this.dataJson.uploadtime;
      console.log(maxSpeed);
      if (maxSpeed <= minSpeed) {
        callback(new Error("频率只能大于等于10"));
      } else {
        callback();
      }
    };
    return {
      checkedCities: [],
      rules: {
        gatewayid: [
          { required: true, message: "请输入网关id", trigger: "blur" },
          { min: 12, max: 12, message: "长度在 12 个字符", trigger: "blur" },
        ],
        port: [{ required: true, message: "请输入端口号", trigger: "blur" }],
        ip: [{ required: true, message: "请输入ip地址", trigger: "blur" }],
        baudrate: [
          { required: true, message: "请输入波特率", trigger: "blur" },
        ],
        parity: [
          { required: true, message: "请输入奇偶校验", trigger: "blur" },
        ],
        uploadtime: [{ validator: speed1, trigger: "blur" }],
        name: [{ required: true, message: "请输入网关名称", trigger: "blur" }],
        address: [
          { required: true, message: "请输入设备安装地址", trigger: "blur" },
        ],
      },
      isagree: sessionStorage.getItem("isagree"),
      roletypeValue: sessionStorage.getItem("roletypeValue"),
      map: null,
      hideListTs: false,
      width: 0,
      fly: false,
      testName: "",
      switchvalue: true, //监控开关
      dialogVisiblesyx: false, //新建摄像头
      value: "",
      textContent: "正在努力加载中...",
      dialogVisible: false,
      tableData: [],
      dialogVisibleTab: false, //table输入框
      dialogVisibleEdit: false, //table表格的修改
      Delectloading: false,
      dialogVisibleselect: false,
      nametext: "",
      dialogVisibleImgs: false,
      lang_file: sessionStorage.getItem("lang_file"),
      fileList: [],
      state: [
        {
          id: "0",
          value: "0",
          label: "离线",
        },
        {
          id: "1",
          value: "1",
          label: "在线",
        },
      ],
      iscontrol: [
        {
          id: "0",
          value: "0",
          label: "否",
        },
        {
          id: "1",
          value: "1",
          label: "是",
        },
      ],
      ismove: [
        {
          id: "0",
          value: "0",
          label: "否",
        },
        {
          id: "1",
          value: "1",
          label: "是",
        },
      ],
      ismonitor: [
        {
          id: "0",
          value: "0",
          label: "否",
        },
        {
          id: "1",
          value: "1",
          label: "是",
        },
      ],
      options: [
        {
          value: "0",
          label: "市电供电 ",
        },
        {
          value: "1",
          label: "电池供电 ",
        },
      ],
      optionsisallonline: [
        {
          value: "0",
          label: "否 ",
        },
        {
          value: "1",
          label: "是 ",
        },
      ],
      dataobjs: {},
      monitor_list: "",
    };
  },
  computed: {
    // 监听复选框
    handChend() {
      let arr = []
      this.checkedCitiesdata .forEach((item)=>{
        if(item != ''){
          arr.push(item)
        }
      })
      this.checkedCities = arr
   
    },
    nwimgs() {
      let flys =
        this.dataJson.addressphoto == ""
          ? false
          : this.dataJson.addressphoto == null
          ? false
          : this.dataJson.addressphoto;
      if (flys) {
        return this.fileList.push({
          url: this.dataJson.addressphoto,
        });
        this.mapList();
      }
    },
  },
  created() {},
  mounted() {
    this.mapList();
    this.G();
    // console.log('111');

    this.lang_fend();
  },
  methods: {
    // 复选框的点击事件
    handleCheckedCitiesChange(e) {
      // this.checkedCities = []
      this.checkedCities = e
    //  let arr = []
    //   e.forEach((item)=>{
    //     if(item != ''){
    //       console.log(item)
    //     }
    //   })
      // console.log(e)

    },
    // 关联摄像头的确定按钮
    async dialogVisiblesyxAdd() {
      this.monitor_list = this.checkedCities.toString();
      
      this.deterMine();
      this.dialogVisiblesyx = false;
    },
    // 关联摄像头
    guan_lian_sexian() {
      this.dialogVisiblesyx = true;
    },
    G(id) {
      return document.getElementById(id);
    },
    mapList() {
      this.map = new BMap.Map(this.$refs.allmap);
      var point = new BMap.Point(116.331398, 39.897445);
      this.map.centerAndZoom(point, 12);
      // 定位功能
      var geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function (r) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var mk = new BMap.Marker(r.point);
          that.map.addOverlay(mk);
          that.map.panTo(r.point);
        } else {
          // alert('failed' + this.getStatus() + "定位失败")
        }
      });
      // var marker = new BMap.Marker(point); // 创建标注
      var ac = new BMap.Autocomplete({
        //建立一个自动完成的对象
        input: "suggestId",
        location: this.map,
      });

      ac.addEventListener("onhighlight", (e) => {
        //鼠标放在下拉列表上的事件
        var str = "";
        var _value = e.fromitem.value;
        var value = "";
        if (e.fromitem.index > -1) {
          value =
            _value.province +
            _value.city +
            _value.district +
            _value.street +
            _value.business;
        }
        str =
          "FromItem<br />index = " +
          e.fromitem.index +
          "<br />value = " +
          value;

        value = "";
        if (e.toitem.index > -1) {
          _value = e.toitem.value;
          value =
            _value.province +
            _value.city +
            _value.district +
            _value.street +
            _value.business;
        }
        str +=
          "<br />ToItem<br />index = " +
          e.toitem.index +
          "<br />value = " +
          value;
        this.G("searchResultPanel").innerHTML = str;
      });
      var myValue;
      ac.addEventListener("onconfirm", (e) => {
        //鼠标点击下拉列表后的事件
        // console.log(e);

        var _value = e.item.value;

        myValue =
          _value.province +
          _value.city +
          _value.district +
          _value.street +
          _value.business;
        this.G("searchResultPanel").innerHTML =
          "onconfirm<br />index = " +
          e.item.index +
          "<br />myValue = " +
          myValue;

        setPlace();
      });
      let that = this;
      function setPlace() {
        that.map.clearOverlays(); //清除地图上所有覆盖物
        function myFun() {
          var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
          that.map.centerAndZoom(pp, 18);
          that.map.addOverlay(new BMap.Marker(pp)); //添加标注
        }

        var local = new BMap.LocalSearch(that.map, {
          //智能搜索
          onSearchComplete: myFun,
        });
        local.search(myValue);
      }

      // 地图标点

      this.map.enableScrollWheelZoom(true); //开启鼠标缩放功能
      // let that = this

      // 地图事件
      function showInfo(e) {
        that.map.clearOverlays();
        // console.log(e.point.lng);
        that.dataJson.longitude = e.point.lng;
        that.dataJson.latitude = e.point.lat;
        var point = new BMap.Point(e.point.lng, e.point.lat);
        var marker = new BMap.Marker(point); //创建标注
        that.map.addOverlay(marker);
      }
      this.map.addEventListener("click", showInfo);
    },
    // 图片详情
    imgDelenetLing() {
      this.dialogVisibleImgs = true;
    },
    // gateway_add_page
    async lang_fend() {
      let page = "gateway_add_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      this.dataobjs = data;
    },

    // 打开侧边栏
    mylnatClick(e) {
      if (e == 0) {
        this.width = 500;
        this.hideListTs = true;
      } else {
        this.width = 0;
        this.hideListTs = false;
      }
    },
    // 开关
    switchChange(e) {
      console.log(e);
      this.fly = !this.fly;
      if (!e) {
        this.testName = "摄像头";
      } else {
        this.testName = "";
      }
    },
    // 删除图片的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    beforeRemove(file, fileList) {
      this.dataJson.addressphoto = "";
      return this.$confirm(`确定移除`);
    },
    //获取图片的钩子
    handlePreview(file) {
      let files = file.raw;
      this.updata(files);
    },
    // 上传图片
    async updata(file) {
      const lang_file = sessionStorage.getItem("lang_file");
      const token = sessionStorage.getItem("token");
      let formData = new FormData();
      formData.append("image", file);
      formData.append("appid", token);
      formData.append("lang_file", lang_file);
      const { code, data, msg } = await autoUpload(formData);
      if (code) {
        this.dataJson.addressphoto = data;
      } else {
        this.$message.error(msg);
      }
    },
    // 显示修改table
    hidelist(e) {
      this.dialogVisibleTab = true;
    },
    // 设置按钮
    handleClick(e) {
      console.log(e);
      // if(e.page){
      let page = e.name || e.page;
      // console.log(page);
      this.$set(this.tableData, e.id, { name: page, id: e.id });
      this.dialogVisibleselect = true;
      // }
    },
    // 创建设备设备号型蛤
    mycheanges() {
      // this.dialogVisible = true;
    },
    // 关闭设备弹框
    dialogVisibleText() {
      let value = this.nametext;
      console.log(value);
      for (let i = 0; i < value; i++) {
        // console.log(i);
        this.tableData.push({ id: i, page: 1 });
      }
      this.dialogVisibleTab = true; //开启table

      // value.forEach(element => {
      //  console.log(element);

      // });
      this.dialogVisible = false;
    },
    //关闭table
    dialogVisibleTabHide() {
      this.dialogVisibleTab = false; //开启table
    },
    //关闭弹框
    cancelClick() {
      // console.log()
      // this.postData();
      this.$emit("cancelClick");
      this.cloneClick();
    },
    //table修改按钮
    mydetile() {
      console.log(11);

      this.dialogVisibleEdit = true;
    },
    //table修改按钮的确定
    dialogVisibleEditClick() {
      this.dialogVisibleEdit = true;
    },
    // 清空标识
    cloneClick() {
      this.$refs.dataForm.resetFields();
    },
    // 确定按钮
    deterMine() {
      this.dialogVisible = true;
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          if (this.dataJson.uuid == undefined) {
            this.dataJson.monitor_list = this.monitor_list;
            const { code, data, msg } = await gatewayAadd(this.dataJson);
            if (code) {
              this.$emit("mygateway_uuid", data);

              this.$message.success(msg);
              this.dialogVisible = false;
              this.postData();
              // this.closefale();
              // this.cloneClick()
            } else {
              this.dialogVisible = false;
              this.$message.error(msg);
            }
          } else {
            // console.log(this.dataJson.uuid);;
            this.dataJson.monitor_list = this.monitor_list;
            const { code, data, msg } = await gatewayAadd(this.dataJson);
            // console.log(code);
            if (code) {
              this.$message.success(msg);
              if (this.areauuid == "") {
                this.upperand();
              } else {
                //如果选择下拉框
                this.postData();
              }
              // if (name != "摄像头") {
              //   this.closefale();
              // }

              //  this.cloneClick()
            } else {
              this.dialogVisible = false;
              this.$message.error(msg);
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // console.log()
    },
  },
};
</script>
<style >
.detile .amap-sug-result {
  z-index: 111111111;
}
#tangram-suggestion--TANGRAM__6g-main {
  z-index: 111111111;
}
.tangram-suggestion-main {
  z-index: 111111111 !important;
}
.mapLint {
  width: 100%;
  position: relative;
  height: 100%;
}

.werp_in {
  position: absolute;
  top: 10px;
  z-index: 99999999999999999;
  right: 30px;
  background: #ffffff;
}
#allmap {
  width: 100%;
  height: 500px;
  /* overflow: hidden; */
  margin: 0;
  font-family: "微软雅黑";
}
#searchResultPanel {
  position: absolute;
  top: 50px;
}
#tangram-suggestion--TANGRAM__3m-main {
  z-index: 9999999999 !important;
}
.detile {
  /* height: 700px; */
  margin: 0 auto;
  width: 100%;
  overflow: auto;
}
.mapLint {
  width: 100%;
  margin: 0 auto;
  height: 440px;
  overflow: hidden;
  /* background: #409eff; */
  position: relative;
}

.content {
  width: 100%;
  padding-bottom: 30px;
}
.url {
  padding-bottom: 10px;
}
.content el-input {
  width: 100%;
}
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.inputs {
  position: relative;
}
.btns {
  position: absolute;
}
.postFit {
  position: absolute;
  left: -34%;
  top: 5px;
}
.divFit {
  position: relative;
}
.bntss {
  position: absolute;
  right: 70px;
}
.bntssTOS {
  position: absolute;
  right: 1px;
}
.upload-demo {
  position: relative;
}
.deitlLint {
  position: absolute;
  top: 6px;
  left: 80px;
}
.lagmnt {
  /* width: 500px; */
  height: 300px;
  position: absolute;
  top: 30%;
  left: 0;
}
.lagmnt1 {
  height: 300px;
  /* background: blue; */
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  position: relative;
}
.leftOS {
  height: 300px;
  background: #409eff;
  width: 20px;
  position: absolute;
  left: 100%;
  top: 0%;
  color: #fff;
  line-height: 80px;
  text-align: center;
}
.box_flex {
  display: flex;
}
</style>